import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePortalEventUrls } from "../usePortalEventUrls";
import { visibleBidStepKeys, type BidStep, type BidStepVisibility } from "./bidWizardSteps";

export const useBidStepNavigation = (eventId: string, bidId: string, visibility: BidStepVisibility) => {
  const navigate = useNavigate();
  const portalUrls = usePortalEventUrls();
  const [searchParams] = useSearchParams();
  const rawStep = searchParams.get("step");
  const currentStep: BidStep | null = visibleBidStepKeys(visibility).includes(rawStep as BidStep)
    ? (rawStep as BidStep)
    : null;

  useEffect(() => {
    if (!currentStep) {
      navigate(portalUrls.bid.edit.go(eventId, bidId).intro);
    }
  }, [currentStep, eventId, bidId, navigate, portalUrls]);

  const navigateToStep = (step: BidStep) => {
    navigate(portalUrls.bid.edit.go(eventId, bidId)[step]);
    window.scrollTo(0, 0);
  };

  return { currentStep, navigateToStep };
};
